// extracted by mini-css-extract-plugin
module.exports = {"followButton":"follow__followButton","follow":"follow__follow","looking":"follow__looking","pulse":"follow__pulse"};